import { PermissionTypes } from '@/constants/permissions'
import { usePermission } from '@/hooks/usePermission'

/**
 * SuperAdmin = platform (Tenants.View). Tenant Admin = customer admin (Users.View, no Tenants.View).
 */
export function useAppRole() {
	const { userHasPermission } = usePermission()
	const isSuperAdmin = userHasPermission(PermissionTypes.Permissions_Tenants_View)
	const isTenantAdmin =
		userHasPermission(PermissionTypes.Permissions_Users_View) && !isSuperAdmin
	const showManageSubscriptionPlansMenu = isSuperAdmin
	const showManagePromoCodesMenu = isSuperAdmin
	const showManageCustomPricingMenu = isSuperAdmin
	const showManageSqlDbdInstallerMenu = isSuperAdmin
	const showBrowsePlansMenu =
		userHasPermission(PermissionTypes.Permissions_MySubscriptions_Purchase) && !isSuperAdmin
	const showMyCustomPlanRequests =
		userHasPermission(PermissionTypes.Permissions_MySubscriptions_Purchase) && !isSuperAdmin
	const showSalesMenu = isSuperAdmin
	const showMySubscriptions =
		userHasPermission(PermissionTypes.Permissions_MySubscriptions_View) && !isSuperAdmin
	const showPaymentMethods =
		userHasPermission(PermissionTypes.Permissions_PaymentMethods_View) && !isSuperAdmin
	const showPaymentHistory =
		userHasPermission(PermissionTypes.Permissions_PaymentHistory_View) && !isSuperAdmin
	const showDashboard = isSuperAdmin || userHasPermission(PermissionTypes.Permissions_Dashboard_View)
	const showHelpCenter =
		userHasPermission(PermissionTypes.Permissions_HelpCenter_View) && !isSuperAdmin
	const showReferral = userHasPermission(PermissionTypes.Permissions_Referral_View) && !isSuperAdmin

	return {
		isSuperAdmin,
		isTenantAdmin,
		showManageSubscriptionPlansMenu,
		showManagePromoCodesMenu,
		showManageCustomPricingMenu,
		showManageSqlDbdInstallerMenu,
		showBrowsePlansMenu,
		showMyCustomPlanRequests,
		showSalesMenu,
		showMySubscriptions,
		showPaymentMethods,
		showPaymentHistory,
		showDashboard,
		showHelpCenter,
		showReferral,
	}
}
